export const tokens = {
    gap: {
        small: 4,
        medium: 6,
        large: 10,
    },
    action: {
        padding: {
            small: 8,
            medium: 16,
            large: 28,
        },
        height: {
            small: 32,
            medium: 48,
            large: 64,
        },
    },
    label: {
        size: {
            small: 13,
            medium: 16,
            large: 24,
        },
    },
};
